import { forwardRef } from 'react';
import OpenDoor from '../Icons/OpenDoor';
import '../styles/components/Button.css';

const Button = forwardRef(
  (
    {
      children,
      variant = 'default',
      className = '',
      backgroundColor = null,
      showIcon = false,
      customIcon = null,
      ...props
    },
    ref
  ) => {
    const buttonClass = `button button--${variant} ${className}`;

    return (
      <button
        className={buttonClass}
        style={{ ...{ backgroundColor }, ...props.style }}
        {...props}
        ref={ref}
      >
        {children}
        {!customIcon && showIcon && <OpenDoor />}
        {customIcon && customIcon}
      </button>
    );
  }
);

export default Button;
